import React, {
  useContext,
  forwardRef,
} from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PoliticalAdsDialog, PoliticalAdsDialogHandle } from './political-ads-dialog';

export const ImportPoliticalAdsDialog = forwardRef<
  PoliticalAdsDialogHandle
>((_, ref) => {
  const i18n = useContext(I18nContext);

  return (
    <PoliticalAdsDialog
      ref={ref}
      dialogContentText={i18n.getString(_TL_("Microsoft Advertising doesn't allow campaigns that are intended for political advertising. To continue, confirm that your political ad declaration is accurate. We'll skip any campaigns marked as political."))}
    />
  );
});
